import { createContext } from "react";

export const XlsImporterSettingsContext = createContext(null);
